import React, { useState, useEffect } from 'react';
import {
  YoutubePlatformIcon,
  TiktokPlatformIcon,
  InstagramPlatformIcon,
  LinkedInPlatformIcon,
  XPlatformIcon
} from '@/components/common/icon';
import { PlatformItems } from '@/interface/common';
import { isMobile } from '@/biz/tool';

interface Props {
  platform: string;
  setPlatform: (platform: string) => void;
}

const PlatformsTab: React.FC<Props> = ({ platform, setPlatform }) => {
  const platforms = [
    {
      platform: 'YouTube',
      Icon: <YoutubePlatformIcon className="w-[18px]" />,
      key: PlatformItems.YOUTUBE
    },
    {
      platform: 'TikTok',
      Icon: <TiktokPlatformIcon className="w-[18px]" />,
      key: PlatformItems.TIKTOK
    },
    {
      platform: 'Instagram',
      Icon: <InstagramPlatformIcon className="w-[18px]" />,
      key: PlatformItems.INSTAGRAM
    },
    {
      platform: 'LinkedIn',
      Icon: <LinkedInPlatformIcon className="w-[18px]" />,
      key: PlatformItems.LINKEDIN
    },
    {
      platform: 'X (Twitter)',
      Icon: <XPlatformIcon className="w-[18px]" />,
      key: PlatformItems.TWITTER
    }
  ];

  return (
    <div
      className={`flex items-center gap-4 mt-6 ${isMobile() ? 'justify-center' : 'justify-start'}`}
    >
      {platforms.map((item, index) => (
        <div
          key={item.key}
          className={`flex-shrink-0 self-stretch px-4 rounded-[20px] h-[40px] inline-flex justify-center items-center gap-2 cursor-pointer ${platform === item.key ? 'bg-[#eff1ff]' : 'border border-[#e8e8e8]'}`}
          onClick={() => setPlatform(item.key)}
        >
          {item.Icon}
          {!isMobile() && (
            <div className="justify-start text-[#1c2024] text-base font-semibold font-['Plus_Jakarta_Sans'] leading-normal">
              {item.platform}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PlatformsTab;
